import { Typography } from '@mui/material'
import {
    FILE_NOT_FOUND_ERROR,
    IMAGE_NOT_FOUND_ERROR,
} from 'hooks/useUpsertWithImage/useUpsertWithImage'
import { Trans, useTranslation } from 'react-i18next'
import { useConfirmDialog } from 'store/actions/ui.action'
import errorMessages from 'utilities/errorMessages'
import toast from 'utilities/toast/toast'
function ComboDisableConfirmation({
    itemName,
    comboItemNameList,
}: {
    itemName: string
    comboItemNameList: string[]
}) {
    const { t } = useTranslation()
    return (
        <>
            <Typography>
                <Trans>
                    {t('products.products.warning.disable_related_combo', {
                        name: itemName ?? 'the product',
                    })}
                </Trans>
            </Typography>

            <ul>
                {comboItemNameList.map((c) => (
                    <li>{c}</li>
                ))}
            </ul>
        </>
    )
}
const useProductErrorHandler = () => {
    const { showConfirmDialog, showErrorMessageDialog } = useConfirmDialog()
    const validationError = (
        itemName: string,
        err: any,
        {
            onAddDuplicatedName,
            onConfirmForceCombo: onForceComboSubmit,
        }: {
            onAddDuplicatedName?: (name: string) => void
            onConfirmForceCombo?: (result: boolean) => void
        },
    ) => {
        const { message, arg } = errorMessages(err)
        if (message === 'item.error.related_combo') {
            showConfirmDialog(
                <ComboDisableConfirmation
                    itemName={itemName}
                    comboItemNameList={arg.combos as string[]}
                />,
                (result: boolean) => {
                    onForceComboSubmit?.(result)
                },
            )
        } else if (
            message === FILE_NOT_FOUND_ERROR ||
            message === IMAGE_NOT_FOUND_ERROR
        )
            showErrorMessageDialog(err)
        else if (message === 'item.error.duplicate.name' && onAddDuplicatedName)
            onAddDuplicatedName(itemName)
        else toast.error(message, arg)
    }
    return { validationError }
}
export default useProductErrorHandler
